import React from 'react';
import { TabContextValue } from './interface';

const TabsContext = React.createContext<TabContextValue>({});

export default TabsContext;